import { useState } from "react";
import landingPageImage1 from "../images/landing-page-1.jpeg";
import landingPageImage2 from "../images/landing-page-2.jpeg";
import landingPageImage3 from "../images/landing-page-3.jpeg";
import landingPageImage4 from "../images/landing-page-4.jpeg";
import Login from "./Login"

const AnimatedHeroBackground = ({ setToken }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const backgroundImages = [
    landingPageImage1,
    landingPageImage2,
    landingPageImage3,
    landingPageImage4,
  ];

  return (
    <>
      <section className="hero is-fullheight" style={{ padding: 0 }}>
        <div style={{ display: "flex", height: "100vh" }}>
          {/* Left side - Background Image with Gradient (2/3 width) - Hidden on mobile */}
          <div
            className="is-hidden-mobile"
            style={{
              flex: "2",
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              overflow: "hidden",
              borderTopRightRadius: "50px",
              borderBottomRightRadius: "50px",
            }}
          >
            {/* Background Images */}
            {backgroundImages.map((image, index) => (
              <div
                key={index}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: `
                      linear-gradient(135deg, rgba(0, 125, 209, 0.85) 0%, rgba(75, 164, 223, 0.75) 50%, rgba(0, 125, 209, 0.9) 100%),
                      url(${image})
                    `,
                  backgroundSize: "110%",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  animation: "backgroundZoom 20s ease-in-out infinite",
                  opacity: currentImageIndex === index ? 1 : 0,
                  transition: "opacity 1.5s ease-in-out",
                  zIndex: currentImageIndex === index ? 2 : 1,
                }}
              />
            ))}
            {/* Content overlay for the background section */}
            <div
              style={{
                textAlign: "center",
                color: "white",
                maxWidth: "500px",
                padding: "2rem",
                position: "relative",
                zIndex: 10,
              }}
            >

              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "300",
                  marginBottom: "1.5rem",
                  textShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
                  lineHeight: "1",
                }}
              >
                Welcome to 
              </h3>

              <h1
                style={{
                  fontSize: "3rem",
                  fontWeight: "500",
                  marginBottom: "1.5rem",
                  textShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
                  lineHeight: "1.2",
                }}
              >
                Environmental Laboratories
              </h1>
              <p
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "300",
                  lineHeight: "1.6",
                  textShadow: "0 1px 5px rgba(0, 0, 0, 0.3)",
                  opacity: "0.95",
                }}
              >
                Your ally in the world of environmental testing and compliance
              </p>
            </div>

            {/* Image indicators */}
            <div
              style={{
                position: "absolute",
                bottom: "2rem",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                gap: "0.5rem",
                zIndex: 10,
              }}
            >
              {backgroundImages.map((_, index) => (
                <div
                  key={index}
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    background:
                      currentImageIndex === index
                        ? "rgba(255, 255, 255, 0.9)"
                        : "rgba(255, 255, 255, 0.4)",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                  }}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          </div>

          {/* Right side - Login Form (1/3 width) */}
          <div
            style={{
              flex: "1",
              background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "2rem",
              minHeight: "100vh",
              borderTopLeftRadius: "50px",
              borderBottomLeftRadius: "50px",
            }}
            className="is-flex-direction-column"
          >
            <div
              style={{
                width: "100%",
                maxWidth: "400px",
              }}
            >
              <div
                className="box"
                style={{
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(20px)",
                  borderRadius: "20px",
                  padding: "3rem 2.5rem",
                  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  animation: "fadeInUp 0.8s ease-out 0.2s both",
                }}
              >
                <Login setToken={setToken} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add custom CSS for animations */}
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes backgroundZoom {
            0% {
              background-size: 110%;
              background-position: center center;
            }
            50% {
              background-size: 120%;
              background-position: center 20%;
            }
            100% {
              background-size: 110%;
              background-position: center center;
            }
          }

          @media (max-width: 600px) {
            .hero > div {
              flex-direction: column !important;
            }
            .hero > div > div:first-child {
              display: none !important;
            }
            .hero > div > div:last-child {
              flex: 1 !important;
              min-height: 100vh !important;
              background: linear-gradient(135deg, #007DD1 0%, #4BA4DF 100%) !important;
              border-radius: 0 !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default AnimatedHeroBackground;
